import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["undefined"];
var _JobProgressionStepSt, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { JobProgressionFlow as JobProgressionFlowProto, JobProgressionStepStatus as JobProgressionStepStatusProto } from '@taxfyle/api-internal/internal/job_progression_pb';
import { Model } from 'libx';
import { isNil, chain } from 'lodash';
import { computed, observable } from 'mobx';
import { maybeParseDate } from 'utils/dateUtil';
import { timestampToISO } from 'utils/grpcUtil';
var JobProgressionStepStatus = (_JobProgressionStepSt = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_JobProgressionStepSt, JobProgressionStepStatusProto.OPEN_ITEMS, 'OPEN_ITEMS'), JobProgressionStepStatusProto.JOB_STARTED, 'JOB_STARTED'), JobProgressionStepStatusProto.DRAFT_IN_REVIEW, 'DRAFT_IN_REVIEW'), JobProgressionStepStatusProto.DRAFT_APPROVED, 'DRAFT_APPROVED'), JobProgressionStepStatusProto.DRAFT_REJECTED, 'DRAFT_REJECTED'), JobProgressionStepStatusProto.AUTHORIZATION_REQUESTED, 'AUTHORIZATION_REQUESTED'), JobProgressionStepStatusProto.AUTHORIZATION_SIGNED, 'AUTHORIZATION_SIGNED'), JobProgressionStepStatusProto.RETURN_FILED, 'RETURN_FILED'), JobProgressionStepStatusProto.DELIVERABLE_COMPLETED, 'DELIVERABLE_COMPLETED'), JobProgressionStepStatusProto.EXTENSION_IN_PROGRESS, 'EXTENSION_IN_PROGRESS'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_JobProgressionStepSt, JobProgressionStepStatusProto.EXTENSION_CONFIRMED, 'EXTENSION_CONFIRMED'), JobProgressionStepStatusProto.EXTENSION_ACCEPTED, 'EXTENSION_ACCEPTED'), JobProgressionStepStatusProto.EXTENSION_REJECTED, 'EXTENSION_REJECTED'), JobProgressionStepStatusProto.PROGRESSION_WAITING_ON_CLIENT, 'WAITING_ON_CLIENT'), JobProgressionStepStatusProto.READY_TO_FILE, 'READY_TO_FILE'), JobProgressionStepStatusProto.NO_PROGRESSION, null));
var JobProgressionFlow = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, JobProgressionFlowProto.NONE, 'NONE'), JobProgressionFlowProto.OUTSOURCING, 'OUTSOURCING'), JobProgressionFlowProto.RETAIL, 'RETAIL'), JobProgressionFlowProto.ESSENTIAL, 'ESSENTIAL'), JobProgressionFlowProto.PERSONAL_EXTENSION, 'PERSONAL_EXTENSION'), JobProgressionFlowProto.BUSINESS_EXTENSION, 'BUSINESS_EXTENSION'), JobProgressionFlowProto.OUTSOURCING_EXTENSION, 'OUTSOURCING_EXTENSION');
var getExtensionStepDetails = function getExtensionStepDetails(stepDetails, currentStep, progressionSteps) {
  if (currentStep === 'WAITING_ON_CLIENT') {
    if (progressionSteps.some(function (p) {
      return p.status === 'EXTENSION_ACCEPTED';
    })) {
      return _objectSpread(_objectSpread({}, stepDetails.WAITING_ON_CLIENT), {}, {
        title: 'Extension accepted'
      });
    } else if (progressionSteps.some(function (p) {
      return p.status === 'EXTENSION_REJECTED';
    })) {
      return _objectSpread(_objectSpread({}, stepDetails.WAITING_ON_CLIENT), {}, {
        title: 'Extension rejected'
      });
    }
  }
  return stepDetails[currentStep];
};
var computeExtensionFlow = function computeExtensionFlow(flow, currentStep, progressionSteps) {
  // If the progressionSteps does not contain EXTENSION_ACCEPTED or EXTENSION_REJECTED as a status, then we need to modify the flow to modify the title and description of EXTENSION_ACCEPTED and remove EXTENSION_REJECTED.
  var hasExtensionAcceptedStep = progressionSteps.some(function (step) {
    return step.status === 'EXTENSION_ACCEPTED';
  });
  var hasExtensionRejectedStep = progressionSteps.some(function (step) {
    return step.status === 'EXTENSION_REJECTED';
  });
  var hasWaitingOnClientStep = progressionSteps.some(function (step) {
    return step.status === 'WAITING_ON_CLIENT';
  });
  if (!hasWaitingOnClientStep) {
    // Filter out WAITING_ON_CLIENT from the flow.
    flow = Object.fromEntries(Object.entries(flow).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];
      return key !== 'WAITING_ON_CLIENT';
    }));
  }
  if (hasExtensionAcceptedStep) {
    // Filter out EXTENSION_REJECTED from the flow.
    var _filteredFlow = Object.fromEntries(Object.entries(flow).filter(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
        key = _ref4[0];
      return key !== 'EXTENSION_REJECTED';
    }));
    return _filteredFlow;
  }
  if (hasExtensionRejectedStep) {
    // Filter out EXTENSION_REJECTED from the flow
    var _filteredFlow2 = Object.fromEntries(Object.entries(flow).filter(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 1),
        key = _ref6[0];
      return key !== 'EXTENSION_ACCEPTED';
    }));
    return _filteredFlow2;
  }

  // Filter out both EXTENSION_ACCEPTED and EXTENSION_REJECTED from the flow.
  // Since the pro has not answered if the extension was accepted or rejected yet.
  var filteredFlow = Object.fromEntries(Object.entries(flow).filter(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 1),
      key = _ref8[0];
    return key !== 'EXTENSION_ACCEPTED' && key !== 'EXTENSION_REJECTED';
  }));
  return _objectSpread(_objectSpread({}, filteredFlow), {}, {
    EXTENSION_ACCEPTED_OR_REJECTED: {
      title: 'Extension accepted/rejected',
      description: 'This step will be updated once the Pro receives the extension status from the IRS.',
      progress: {
        completed: 75,
        pending: 33
      }
    }
  });
};
var computeProgressionFlow = function computeProgressionFlow(flow, currentStep, progressionSteps, isExtensionFlow) {
  if (isExtensionFlow) {
    flow = computeExtensionFlow(flow, currentStep, progressionSteps);
  }
  var _flow = flow,
    initialStep = _flow[null],
    steps = _objectWithoutProperties(_flow, _excluded);
  var computedFlow = chain(steps).values().filter(function (step) {
    return step !== initialStep;
  }).sortBy('progress.completed').thru(function (steps) {
    return [initialStep].concat(_toConsumableArray(steps));
  }).cloneDeep().thru(setStepCompletion).value();
  return computedFlow;
  function setStepCompletion(steps) {
    if (!currentStep) {
      return steps;
    }
    var currentStepIndex = steps.findIndex(function (step) {
      return step.title === currentStep.title;
    });
    return steps.map(function (step, index) {
      return _objectSpread(_objectSpread({}, step), {}, {
        done: index < currentStepIndex
      });
    });
  }
};
export var JobProgression = (_class = /*#__PURE__*/function (_Model) {
  function JobProgression() {
    var _this;
    _classCallCheck(this, JobProgression);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, JobProgression, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "jobId", _descriptor2, _this);
    _initializerDefineProperty(_this, "progressionSteps", _descriptor3, _this);
    _initializerDefineProperty(_this, "flow", _descriptor4, _this);
    return _this;
  }
  _inherits(JobProgression, _Model);
  return _createClass(JobProgression, [{
    key: "currentStepInfo",
    get: function get() {
      var _this$progressionStep, _this$progressionStep2;
      var currentStep = (_this$progressionStep = (_this$progressionStep2 = this.progressionSteps.find(function (p) {
        return isNil(p.response);
      })) === null || _this$progressionStep2 === void 0 ? void 0 : _this$progressionStep2.status) !== null && _this$progressionStep !== void 0 ? _this$progressionStep : JobProgressionStepStatus[JobProgressionStepStatusProto.NO_PROGRESSION];
      switch (this.flow) {
        case JobProgressionFlow[JobProgressionFlowProto.OUTSOURCING]:
          return OutsourcingProgressionStepsDetails[currentStep];
        case JobProgressionFlow[JobProgressionFlowProto.RETAIL]:
          return RetailProgressionStepsDetails[currentStep];
        case JobProgressionFlow[JobProgressionFlowProto.ESSENTIAL]:
          return EssentialProgressionStepsDetails[currentStep];
        case JobProgressionFlow[JobProgressionFlowProto.PERSONAL_EXTENSION]:
          return getExtensionStepDetails(PersonalExtensionProgressionStepsDetails, currentStep, this.progressionSteps);
        case JobProgressionFlow[JobProgressionFlowProto.BUSINESS_EXTENSION]:
          return getExtensionStepDetails(BusinessExtensionProgressionStepsDetails, currentStep, this.progressionSteps);
        case JobProgressionFlow[JobProgressionFlowProto.OUTSOURCING_EXTENSION]:
          return OutsourcingExtensionProgressionStepsDetails[currentStep];
      }
      return OutsourcingProgressionStepsDetails[currentStep];
    }
  }, {
    key: "stepsInfo",
    get: function get() {
      switch (this.flow) {
        case JobProgressionFlow[JobProgressionFlowProto.OUTSOURCING]:
          return computeProgressionFlow(OutsourcingProgressionStepsDetails, this.currentStepInfo, this.progressionSteps, false);
        case JobProgressionFlow[JobProgressionFlowProto.RETAIL]:
          return computeProgressionFlow(RetailProgressionStepsDetails, this.currentStepInfo, this.progressionSteps, false);
        case JobProgressionFlow[JobProgressionFlowProto.ESSENTIAL]:
          return computeProgressionFlow(EssentialProgressionStepsDetails, this.currentStepInfo, this.progressionSteps, false);
        case JobProgressionFlow[JobProgressionFlowProto.PERSONAL_EXTENSION]:
          return computeProgressionFlow(PersonalExtensionProgressionStepsDetails, this.currentStepInfo, this.progressionSteps, true);
        case JobProgressionFlow[JobProgressionFlowProto.BUSINESS_EXTENSION]:
          return computeProgressionFlow(BusinessExtensionProgressionStepsDetails, this.currentStepInfo, this.progressionSteps, true);
        case JobProgressionFlow[JobProgressionFlowProto.OUTSOURCING_EXTENSION]:
          return computeProgressionFlow(OutsourcingExtensionProgressionStepsDetails, this.currentStepInfo, this.progressionSteps, false);
      }
      return computeProgressionFlow(OutsourcingProgressionStepsDetails, this.currentStepInfo, this.progressionSteps, false);
    }
  }, {
    key: "isExtensionFlow",
    get: function get() {
      return this.flow === JobProgressionFlow[JobProgressionFlowProto.PERSONAL_EXTENSION] || this.flow === JobProgressionFlow[JobProgressionFlowProto.BUSINESS_EXTENSION];
    }
  }, {
    key: "parse",
    value: function parse(progression) {
      var _progression$progress, _progression$progress2;
      return {
        id: progression.id,
        jobId: progression.jobId,
        flow: JobProgressionFlow[progression.flow],
        progressionSteps: (_progression$progress = (_progression$progress2 = progression.progressionSteps) === null || _progression$progress2 === void 0 ? void 0 : _progression$progress2.map(function (step) {
          return {
            flow: JobProgressionFlow[progression.flow],
            jobId: progression.jobId,
            id: step.id,
            status: JobProgressionStepStatus[step.progressionStep],
            response: JobProgressionStepStatus[step.response],
            dateCreated: maybeParseDate(timestampToISO(step.dateCreated)),
            dateResponded: maybeParseDate(timestampToISO(step.dateResponded))
          };
        })) !== null && _progression$progress !== void 0 ? _progression$progress : []
      };
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "jobId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "progressionSteps", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "flow", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return JobProgressionFlow[JobProgressionFlowProto.NONE];
  }
}), _applyDecoratedDescriptor(_class.prototype, "currentStepInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentStepInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "stepsInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "stepsInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isExtensionFlow", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isExtensionFlow"), _class.prototype), _class);
var OutsourcingProgressionStepsDetails = {
  OPEN_ITEMS: {
    title: 'Documents missing',
    description: 'There are outstanding documents. Your Pro will share a missing items list to review. Please upload all outstanding items and notify your Pro once completed.',
    progress: {
      completed: 0,
      pending: 20
    },
    isRejection: true
  },
  JOB_STARTED: {
    title: 'Job started',
    description: 'A draft return is being prepared. When ready, your Pro will contact you to review.',
    progress: {
      completed: 33,
      pending: 20
    }
  },
  DRAFT_IN_REVIEW: {
    title: 'Draft review',
    description: 'Your Pro has finalized a draft return for review. Please review and notify your Pro if any changes are necessary.',
    progress: {
      completed: 66,
      pending: 20
    }
  },
  DRAFT_APPROVED: {
    title: 'Draft approved',
    description: 'You approved the draft return. Your Pro will check back in to finalize your return and complete the job.',
    progress: {
      completed: 80,
      pending: 20
    }
  },
  DRAFT_REJECTED: {
    title: 'Changes requested',
    description: 'You requested changes to the return. Once revised, your Pro will request another draft approval from you.',
    progress: {
      completed: 50,
      pending: 20
    },
    isRejection: true
  },
  null: {
    title: 'Document review',
    description: 'Please ensure that all necessary documents are uploaded. Your Pro will reach out if there are any open items outstanding.',
    progress: {
      completed: 0,
      pending: 20
    }
  }
};
var RetailProgressionStepsDetails = {
  OPEN_ITEMS: {
    title: 'Documents missing',
    description: 'There are outstanding documents. Your Pro will share a missing items list to review. Please upload all outstanding items and notify your Pro once completed.',
    progress: {
      completed: 0,
      pending: 20
    }
  },
  JOB_STARTED: {
    title: 'Draft preparation',
    description: 'A draft return is being prepared. When ready, your Pro will contact you to review.',
    progress: {
      completed: 20,
      pending: 20
    }
  },
  DRAFT_IN_REVIEW: {
    title: 'Draft review',
    description: 'Your Pro has finalized a draft return for review. Please review and notify your Pro if any changes are necessary.',
    progress: {
      completed: 40,
      pending: 20
    }
  },
  DRAFT_APPROVED: {
    title: 'Draft approved',
    description: 'You approved the draft return. Your Pro will check back in to finalize your return and complete the job.',
    progress: {
      completed: 50,
      pending: 20
    }
  },
  DRAFT_REJECTED: {
    title: 'Changes requested',
    description: 'You requested changes to the return. Once revised, your Pro will request another draft approval from you.',
    progress: {
      completed: 40,
      pending: 20
    },
    isRejection: true
  },
  AUTHORIZATION_REQUESTED: {
    title: 'Authorization requested',
    description: 'Your Pro has completed your return. Please sign the authorization form and notify your Pro in chat when completed.',
    progress: {
      completed: 60,
      pending: 20
    }
  },
  AUTHORIZATION_SIGNED: {
    title: 'Authorization signed',
    description: 'Your Pro will now e-file your return. Please wait for confirmation.',
    progress: {
      completed: 70,
      pending: 20
    }
  },
  RETURN_FILED: {
    title: 'Return filed',
    description: 'Good news! Your Pro has filed your return, and will now proceed to complete the job.',
    progress: {
      completed: 80,
      pending: 20
    }
  },
  null: {
    title: 'Document review',
    description: 'Please ensure that all necessary documents are uploaded. Your Pro will reach out if there are any open items outstanding.',
    progress: {
      completed: 0,
      pending: 20
    }
  }
};
var EssentialProgressionStepsDetails = {
  JOB_STARTED: {
    title: 'Job in progress',
    description: 'The deliverable is being prepared.',
    progress: {
      completed: 33,
      pending: 33
    }
  },
  DELIVERABLE_COMPLETED: {
    title: 'Job Completed',
    description: 'Your pro has completed the work and will close the job soon.',
    progress: {
      completed: 67,
      pending: 33
    }
  },
  null: {
    title: 'Job Submitted',
    description: 'A pro will begin working on the job shortly.  At this stage, we can no longer accept any documents.',
    progress: {
      completed: 0,
      pending: 33
    }
  }
};
var PersonalExtensionProgressionStepsDetails = {
  EXTENSION_IN_PROGRESS: {
    title: 'Extension in progress',
    description: 'Your extension is being prepared. Once your Pro has finished, they will upload the e-file confirmation.',
    progress: {
      completed: 33,
      pending: 33
    }
  },
  EXTENSION_CONFIRMED: {
    title: 'Extension status',
    description: 'Your pro has filed an extension on your behalf. You will receive an update when the IRS has either accepted or rejected the extension.',
    progress: {
      completed: 67,
      pending: 33
    }
  },
  EXTENSION_ACCEPTED: {
    title: 'Extension accepted',
    description: 'The extension was successfully accepted by the IRS.',
    progress: {
      completed: 75,
      pending: 33
    }
  },
  EXTENSION_REJECTED: {
    title: 'Extension rejected',
    description: 'The extension was rejected by the IRS. This could be due to an already filed extension on your behalf. Your pro can answer any questions you might have.',
    progress: {
      completed: 75,
      pending: 33
    }
  },
  WAITING_ON_CLIENT: {
    title: 'Resume job when ready',
    description: 'Please notify your pro when you’re ready to resume your tax return.',
    progress: {
      completed: 85,
      pending: 33
    }
  },
  null: {
    title: 'Not started',
    description: 'Please ensure that all necessary documents are prepared. Your pro will contact you if any additional information is needed.',
    progress: {
      completed: 0,
      pending: 20
    }
  }
};
var BusinessExtensionProgressionStepsDetails = {
  EXTENSION_IN_PROGRESS: {
    title: 'Extension in progress',
    description: 'Your extension is being prepared. Once your Pro has finished, they will upload the e-file confirmation.',
    progress: {
      completed: 33,
      pending: 33
    }
  },
  EXTENSION_CONFIRMED: {
    title: 'Extension status',
    description: 'Your pro has filed an extension on your behalf. You will receive an update when the IRS has either accepted or rejected the extension.',
    progress: {
      completed: 67,
      pending: 33
    }
  },
  EXTENSION_ACCEPTED: {
    title: 'Extension accepted',
    description: 'The extension was successfully accepted by the IRS.',
    progress: {
      completed: 75,
      pending: 33
    }
  },
  EXTENSION_REJECTED: {
    title: 'Extension rejected',
    description: 'The extension was rejected by the IRS. This could be due to an already filed extension on your behalf. Your pro can answer any questions you might have.',
    progress: {
      completed: 75,
      pending: 33
    }
  },
  WAITING_ON_CLIENT: {
    title: 'Resume job when ready',
    description: 'Please notify your pro when you’re ready to resume your tax return.',
    progress: {
      completed: 85,
      pending: 33
    }
  },
  null: {
    title: 'Not started',
    description: 'Please ensure that all necessary documents are prepared. Your pro will contact you if any additional information is needed.',
    progress: {
      completed: 0,
      pending: 20
    }
  }
};
var OutsourcingExtensionProgressionStepsDetails = {
  WAITING_ON_CLIENT: {
    title: 'Resume job when ready',
    description: 'Please notify your pro when you’re ready to continue.',
    progress: {
      completed: 85,
      pending: 33
    }
  },
  READY_TO_FILE: {
    title: 'Extension completed',
    description: 'The extension was successfully completed by your Pro.',
    progress: {
      completed: 100,
      pending: 0
    }
  },
  null: {
    title: 'Not started',
    description: 'Please ensure that all necessary documents are prepared. Your pro will contact you if any additional information is needed.',
    progress: {
      completed: 0,
      pending: 20
    }
  }
};
//# sourceMappingURL=JobProgression.js.map
